module.exports = require("body-parser");


//////////////////
// WEBPACK FOOTER
// external "body-parser"
// module id = 36
// module chunks = 0